/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
import sha256 from "crypto-js/sha256";
import * as CryptoJS from "crypto-js";
import i18n from "i18n/i18n";
import { PATH_NAME } from "constants/enum";
import { REGEX } from "constants/regex";
import { Flex, Text, Title } from "@mantine/core";
import { v4 as uuidv4 } from "uuid";
import { isNaN } from "lodash";
import env from "../env";
import { AnyObject } from "../constants/types";

const encode = (data: string) => {
  const sha256digest = sha256(data);
  return CryptoJS.enc.Hex.stringify(sha256digest);
};

const maskCharacter = (number: string) => {
  const mask = "*";
  const maskedNumber =
    number.substring(0, 2) + mask.repeat(6) + number.slice(-2);
  // const maskedNumber = number + mask + number;
  return maskedNumber;
};

const maskCreditNumber = (number: string) => {
  const mask = "*";
  const lenthCredit = number.length;
  const repeat = lenthCredit <= 10 ? 6 : lenthCredit - 10;
  const maskedNumber =
    number.substring(0, 6) + mask.repeat(repeat) + number.slice(-4);
  return maskedNumber;
};

const getMillisecondFromMinute = (minute: number) => {
  return Date.now() + 1000 * 60 * minute;
};

const getBreadCrumbsNameFromPath = (path: string) => {
  switch (path) {
    case PATH_NAME.DASHBOARD:
      return `${i18n.t("HOME")}`;
    // TÍN DỤNG VÀ TTTM
    case "credit":
      return i18n.t("CREDIT_AND_TRADE_FINANCE");
    case "disbursement":
      return i18n.t("DISBURSEMENT");
    // CHUYỂN TIỀN
    case PATH_NAME.TRANSFER_MONEY:
      return `${i18n.t("TRANSFER_MONEY")}`;
    case PATH_NAME.TRANSFER_BY_PHONE:
      return `${i18n.t("TRANSFER_BY_PHONE")}`;
    case PATH_NAME.TRANSFER_BY_ACCOUNT:
      return `${i18n.t("TRANSFER_BY_ACCOUNT")}`;
    case PATH_NAME.TRANSFER_BY_CARD:
      return `${i18n.t("TRANSFER_BY_CARD")}`;
    case PATH_NAME.TRANFER_BY_BATCH:
      return `${i18n.t("TRANSFER_BY_BATCH")}`;
    case "trans-international":
      return `${i18n.t("INTERNATIONAL_TRANSFER")}`;
    // DUYỆT GIAO DỊCH
    case PATH_NAME.MANAGE_TRANSACTION:
      return `${i18n.t("MANAGE_TRANSACTION")}`;
    case PATH_NAME.TRANSACTION_LIST:
      return `${i18n.t("TRANSACTION_LIST")}`;
    case PATH_NAME.DETAIL_TRANSACTION:
      return `${i18n.t("DETAIL_TRANSACTION")}`;
    case PATH_NAME.TRANSACTION_HISTORY:
      return `${i18n.t("TRANSACTION_HISTORY")}`;
    case PATH_NAME.CARD_TRANSACTION_DETAIL:
      return i18n.t("TRANSACTION_HISTORY_DETAILS");
    // JVC-3517: breadcrumb màn xác nhận "Thiết lập hạn mức thẻ" thiếu leaf
    case "limit-setting":
      return i18n.t("UPDATE_LIMIT");
    case PATH_NAME.BENEFICIARY_TEMPLATE:
      return i18n.t("BENEFICIARY_OR_TEMPLATE");
    // TÀI KHOẢN/THẺ
    case PATH_NAME.ACCOUNTS:
      return `${i18n.t("ACCOUNT_CARD")}`;
    case PATH_NAME.ACCOUNTS_LIST:
      return `${i18n.t("CURRENT_ACCOUNT")}`;
    case PATH_NAME.TERM_DEPOSIT:
      return i18n.t("DEPOSIT_MENU");
    case PATH_NAME.TERM_DEPOSIT_LIST:
      return i18n.t("TERM_DEPOSIT_LIST");
    case PATH_NAME.TERM_DETAIL:
      return i18n.t("TERM_DEPOSIT_DETAILS");
    case PATH_NAME.LIST_SAVINGS:
      return i18n.t("OPEN_DEPOSIT_ACCOUNT");
    case PATH_NAME.FORM:
      return `${i18n.t("OPEN_A_DEPOSIT_ACCOUNT")}`;
    case PATH_NAME.ACCOUNTS_DETAIL:
      return `${i18n.t("ACCOUNTS_DETAIL")}`;
    case PATH_NAME.CARDS:
      return `${i18n.t("CARDS")}`;
    case PATH_NAME.CARDS_DETAIL:
      return `${i18n.t("CARDS_DETAIL")}`;
    case PATH_NAME.CARDS_LIST:
      return `${i18n.t("CARDS_LIST")}`;
    // THANH TOÁN
    case PATH_NAME.MANAGE_PAYMENT:
      return `${i18n.t("MANAGE_PAYMENT")}`;
    case PATH_NAME.BILL_PAYMENT:
      return `${i18n.t("BILL_PAYMENT")}`;
    case PATH_NAME.NOTIFICATIONS:
      return `${i18n.t("NOTIFICATIONS")}`;
    // CÀI ĐẶT
    case PATH_NAME.SETTING:
      return `${i18n.t("SETTING")}`;
    case PATH_NAME.USER_PROFILE:
      return `${i18n.t("USER_PROFILE")}`;
    case PATH_NAME.CHANGE_PASSWORD:
      return `${i18n.t("CHANGE_PASSWORD")}`;
    case PATH_NAME.USER_LIMIT:
      return `${i18n.t("USER_LIMIT")}`;
    case PATH_NAME.DEVICE_MANAGEMENT:
      return `${i18n.t("DEVICE_MANAGEMENT")}`;
    case PATH_NAME.NOTIFICATION_SETTINGS:
      return `${i18n.t("NOTIFICATION_SETTINGS")}`;
    case PATH_NAME.ABOUT:
      return `${i18n.t("ABOUT")}`;
    case PATH_NAME.TERMS_AND_CONDITIONS:
      return `${i18n.t("TERMS_AND_CONDITIONS")}`;
    case PATH_NAME.OPEN_CURRENT_ACCOUNT:
      return `${i18n.t("OPEN_CURRENT_ACCOUNT")}`;
    // case PATH_NAME.TERM_DEPOSIT:
    //   return `${i18n.t("TERM_DEPOSIT")}`;
    case PATH_NAME.TERM_DEPOSIT_DETAIL:
      return `${i18n.t("OPEN_A_TERM_DEPOSIT_ACCOUNT")}`;
    case PATH_NAME.FINALIZE_DEPOSIT:
      return i18n.t("FINALIZE_DEPOSIT");
    case PATH_NAME.TERM_LOAN:
      return `${i18n.t("SAVING")}`;
    case PATH_NAME.COSUMER_LOAN:
      return `${i18n.t("COSUMER_LOAN")}`;
    case PATH_NAME.LOAN_SETTLEMENT:
      return `${i18n.t("LOAN_SETTLEMENT")}`;
    case PATH_NAME.DEPOSIT_SETTLEMENT:
      return `${i18n.t("DEPOSIT_SETTLEMENT")}`;
    case PATH_NAME.PARTIAL_WITHDRAWAL:
      return i18n.t("REMOVE_THE_ROOT_PART_BY_PART");
    case PATH_NAME.TRANSACTION_RESPONSE:
      return `${i18n.t("TRANSACTION_RESPONSE")}`;
    // Mua bán ngoại tệ
    case PATH_NAME.FOREIGN_CURRENCY:
      return i18n.t("FOREIGN_EXCHANGE_TRANSACTION");
    case PATH_NAME.SELL_FOREIGN_CURRENCY:
      return `${i18n.t("SELL_FOREIGN_CURRENCY")}`;
    // Nộp ngân sách nhà nước
    case PATH_NAME.NOP_NSNN:
    case PATH_NAME.GOV:
      return `${i18n.t("GOV_PAYMENT")}`;
    case PATH_NAME.BUY_CURRENCY_EXCHANGE:
      return `${i18n.t("BUY_FOREIGN_CURRENCY")}`;
    case PATH_NAME.DOMESTIC_TAX_PAYMENT:
      return `${i18n.t("DOMESTIC_TAX_PAYMENT")}`;
    case PATH_NAME.CUSTOMS_DUTY_PAYMENT:
      return `${i18n.t("CUSTOMS_DUTY_PAYMENT")}`;
    case PATH_NAME.REGISTARTION_FREE:
      return `${i18n.t("REGISTARTION_FREE")}`;
    case PATH_NAME.CORPORATE_GOVERNANCE:
      return i18n.t("ENTERPRISE_ADMINISTRATION");
    case PATH_NAME.PERMISSION_MANAGEMENT:
      return i18n.t("PERMISSION_MATRIX");
    default:
      return "";
  }
};

const toCurrency = (value: number) => {
  if (!value && value !== 0) return "";
  return value
    .toString()
    .replace(/\s+/g, "")
    .replace(/,/g, ".")
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
};

// Hiển thị số tiền giao dịch theo loại tiền BE trả về.
// 2 API getTransactionList trả field khác nhau:
//  - transactionListResList: có `amountTransferDisplay` ("1 USD", "39,040,000 "),
//    không có `currency`. Display thiếu mã tiền -> mặc định VND.
//  - transactionListRes: không có display, có `currency` ("USD") +
//    `amountTransfer` (chuỗi/số đã format).
const formatTransactionAmountDisplay = (
  amountTransferDisplay?: string,
  amountTransfer?: number | string,
  currency?: string,
): string => {
  const raw = (amountTransferDisplay || "").trim();
  if (raw) {
    // Đã kèm mã tiền (chữ cái) -> giữ nguyên; chỉ có số -> gắn currency/VND.
    return /[A-Za-z]/.test(raw) ? raw : `${raw} ${currency || "VND"}`;
  }
  return `${toCurrency(amountTransfer as number)} ${currency || "VND"}`.trim();
};

export const parseBalance = (value?: string | number | null): number => {
  if (value === null || value === undefined || value === "") return 0;
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }
  // Strip mọi ký tự không thuộc số/scientific-notation/dấu chấm/dấu trừ.
  // Giữ lại e/E/+ để parse đúng "1.0E12"; bỏ dấu phẩy phân tách hàng nghìn
  // và hậu tố đơn vị (vd " VND") trên các trường *Display.
  const cleaned = value.replace(/[^\d.eE+-]/g, "");
  const parsed = Number(cleaned);
  return Number.isFinite(parsed) ? parsed : 0;
};

const removeVietnameseTones = (str: string) => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g, " ");
  // str = str.trim();
  // Remove punctuations
  // Bỏ dấu câu, kí tự đặc biệt
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\\=|\\<|\\>|\?|\/|,|\.|\\:|\\;|\\'|\\"|\\&|\\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    " ",
  );
  return str;
};

const isWhiteCharacter = (value: string) =>
  value === " " ||
  value === "\f" ||
  value === "\n" ||
  value === "\r" ||
  value === "\t" ||
  value === "\v" ||
  value === "\u00a0" ||
  value === "\u1680" ||
  value === "\u2000" ||
  value === "\u2001" ||
  value === "\u2002" ||
  value === "\u2003" ||
  value === "\u2004" ||
  value === "\u2005" ||
  value === "\u2006" ||
  value === "\u2007" ||
  value === "\u2008" ||
  value === "\u2009" ||
  value === "\u200a" ||
  value === "\u2028" ||
  value === "\u2029" ||
  value === "\u202f" ||
  value === "\u205f" ||
  value === "\u3000" ||
  value === "\ufeff";

const createShortcut = (text: string, limit: number) => {
  if (text.length > limit) {
    let ending = false;
    // eslint-disable-next-line no-plusplus
    for (let i = limit - 3; i > -1; --i) {
      if (isWhiteCharacter(text[i])) {
        ending = true;
      } else if (ending) {
        limit = i + 4;
        break;
      }
    }
    const part = text.substring(0, limit - 3);
    return `${part}...`;
  }
  return text;
};

const preventSpecialCharacter = (e: any) => {
  if (!e.key.match(REGEX.NO_SPECIAL_CHARACTER)) {
    e.preventDefault();
  }
};

const preventMinus = (e: any) => {
  if (
    e.code === "Minus" ||
    e.code === "NumpadSubtract" ||
    e.code === "NumpadAdd"
  ) {
    e.preventDefault();
  }
};

const preventPasteNegative = (e: any) => {
  const clipboardData = e.clipboardData || (window as any).clipboardData;
  const pastedData = parseFloat(clipboardData.getData("text"));

  if (pastedData < 0) {
    e.preventDefault();
  }
};

const formatCurrency = (
  amount: number | string | undefined = 0,
  locale: string = "vi-VN",
  currency: string = "VND",
): string => {
  const numericAmount = Number(amount);

  if (isNaN(numericAmount)) return "0";

  return new Intl.NumberFormat(locale).format(numericAmount);
};

const formatAccountNumber = (value: string) => {
  return value.replace(/(\d{4})(?=\d)/g, "$1 ");
};

function convertNumberToWords(number: number, lang?: "vi" | "en"): string {
  const resolvedLang = lang ?? "vi"; // mặc định là 'vi' nếu lang undefined

  if (number === 0) return resolvedLang === "vi" ? "Không đồng" : "Zero dong";

  const languages = {
    vi: {
      units: [
        "",
        "một",
        "hai",
        "ba",
        "bốn",
        "năm",
        "sáu",
        "bảy",
        "tám",
        "chín",
      ],
      tens: [
        "",
        "mười",
        "hai mươi",
        "ba mươi",
        "bốn mươi",
        "năm mươi",
        "sáu mươi",
        "bảy mươi",
        "tám mươi",
        "chín mươi",
      ],
      places: ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"],
      currency: "đồng",
    },
    en: {
      units: [
        "",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
      ],
      tens: [
        "",
        "ten",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
      ],
      places: ["", "thousand", "million", "billion", "trillion", "quadrillion"],
      currency: "dong",
    },
  };

  const langData = languages[resolvedLang];

  function readThreeDigits(num: number): string {
    let str = "";
    const hundred = Math.floor(num / 100);
    const ten = Math.floor((num % 100) / 10);
    const unit = num % 10;

    if (hundred > 0) {
      str +=
        langData.units[hundred] +
        (resolvedLang === "vi" ? " trăm" : " hundred");
      if (ten === 0 && unit > 0) str += resolvedLang === "vi" ? " lẻ" : " and";
    }

    if (ten > 1) {
      str += ` ${langData.tens[ten]}`;
      if (unit > 0) str += ` ${langData.units[unit]}`;
    } else if (ten === 1) {
      if (unit === 0) str += resolvedLang === "vi" ? " mười" : " ten";
      else if (unit === 5 && resolvedLang === "vi") str += " mười lăm";
      else {
        const teenNumbers = [
          "eleven",
          "twelve",
          "thirteen",
          "fourteen",
          "fifteen",
          "sixteen",
          "seventeen",
          "eighteen",
          "nineteen",
        ];
        str = ` ${
          resolvedLang === "vi"
            ? `mười ${langData.units[unit]}`
            : teenNumbers[unit - 1]
        }`;
      }
    } else if (unit > 0) {
      str += ` ${langData.units[unit]}`;
    }

    return str.trim();
  }

  let result = "";
  let placeIndex = 0;

  while (number > 0) {
    const chunk = number % 1000;
    if (chunk > 0) {
      let chunkText = readThreeDigits(chunk);
      if (placeIndex > 0) chunkText += ` ${langData.places[placeIndex]}`;
      result = `${chunkText} ${result}`;
    }
    number = Math.floor(number / 1000);
    placeIndex++;
  }

  result = result.trim();
  result = result.charAt(0).toUpperCase() + result.slice(1);

  return `${result} ${langData.currency}`;
}

const renderInfoSection = (
  title: string,
  data: { label: string; value: string; color?: string }[],
) => (
  <Flex direction="column" gap="md" fz="md">
    <Title order={4}>{title}</Title>
    <Flex direction="column" gap="lg">
      {data.map((item, index) => (
        <Flex key={uuidv4()} gap="md">
          <Text w={300}>{item.label}</Text>
          <Text fw={600} c={item.color || "#2E2E2E"}>
            {item.value}
          </Text>
        </Flex>
      ))}
    </Flex>
  </Flex>
);

function isDateStringToday(dateStr: string) {
  const [timePart, datePart] = dateStr.split(" ");
  const [hours, minutes, seconds] = timePart.split(":").map(Number);
  const [day, month, year] = datePart.split("/").map(Number);

  const inputDate = new Date(year, month - 1, day, hours, minutes, seconds);
  const today = new Date();

  return (
    inputDate.getDate() === today.getDate() &&
    inputDate.getMonth() === today.getMonth() &&
    inputDate.getFullYear() === today.getFullYear()
  );
}

export function parseTimeAndDate(dateStr: string) {
  const [timePart, datePart] = dateStr.split(" ");
  const [hours, minutes] = timePart.split(":");

  return {
    time: `${hours}:${minutes}`, // 16:18
    date: datePart, // 01/06/2025
  };
}

const { SECRET_KEY } = env;

export const encrypt = (text: string): string => {
  const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
  return encodeURIComponent(encrypted); // đảm bảo an toàn trên URL
};

export const decrypt = (cipherText: string): string => {
  const decoded = decodeURIComponent(cipherText); // lấy lại chuỗi ban đầu
  const bytes = CryptoJS.AES.decrypt(decoded, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

// 🔐 Mã hóa 1 object bất kỳ
export const encryptObject = (obj: Record<string, any>) => {
  const jsonStr = JSON.stringify(obj);
  return CryptoJS.AES.encrypt(jsonStr, SECRET_KEY).toString();
};

// 🔓 Giải mã và parse lại object
export const decryptObject = (encrypted: string): Record<string, any> => {
  const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
  const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);

  try {
    return JSON.parse(decryptedStr);
  } catch (error) {
    console.error("❌ Failed to parse decrypted object:", error);
    return {};
  }
};

/**
 * Hàm xử lý định dạng tiền tệ khi nhập
 * @param value - Chuỗi người dùng nhập vào
 * @returns Chuỗi được định dạng theo "vi-VN" (VD: 1.000.000)
 */
export const handleCurrencyInput = (value: string): string => {
  const numeric = value.replace(/[^\d]/g, "");
  if (!numeric) return "";
  const number = parseInt(numeric, 10);
  return number.toLocaleString("vi-VN");
};

export const formatDate = (date?: Date) =>
  date ? date.toISOString().slice(0, 10).replace(/-/g, "") : "";

export const formatDateTime = (value?: string | number | Date): string => {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

export function convertArrWithKey<T>(array: T[], keys: keyof T) {
  if (!array) return null;
  let result: AnyObject = {};
  array.forEach((item) => {
    const key = item[keys] as string;
    result = { ...result, [key]: item };
  });
  return result;
}

/**
 * Kiểm tra text có chứa keyword không — không phân biệt hoa thường & dấu tiếng Việt.
 * "Chuyen" khớp "Chuyển VCB", "Chuyển" khớp "Chuyen VCB", search chính xác vẫn khớp.
 */
const containsIgnoreAccent = (
  text?: string | null,
  keyword?: string | null,
): boolean =>
  removeVietnameseTones(String(text ?? ""))
    .toLowerCase()
    .includes(removeVietnameseTones(String(keyword ?? "")).toLowerCase());

export {
  encode,
  maskCharacter,
  getMillisecondFromMinute,
  getBreadCrumbsNameFromPath,
  toCurrency,
  formatTransactionAmountDisplay,
  removeVietnameseTones,
  containsIgnoreAccent,
  createShortcut,
  preventMinus,
  preventSpecialCharacter,
  preventPasteNegative,
  maskCreditNumber,
  formatCurrency,
  formatAccountNumber,
  convertNumberToWords,
  renderInfoSection,
  isDateStringToday,
};
